export enum TimeZone {
  AmericaNewYork = "America/New_York",
  AmericaChicago = "America/Chicago",
  AmericaDenver = "America/Denver",
  AmericaLosAngeles = "America/Los_Angeles",
  AmericaAnchorage = "America/Anchorage",
  AmericaAdak = "America/Adak",
  PacificHonolulu = "Pacific/Honolulu",
  AmericaPhoenix = "America/Phoenix",
}

export const VALID_TIMEZONES = Object.values(TimeZone);
